import React from 'react';
import { array, bool, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { setCheckoutDrawerOpen } from '../../../actions/checkoutPlan';
import {
    getPackageById,
    isRecurringGig
} from '../../../reducers/packages';
import { selectPackage } from '../../../actions/packages';
import { eligibleForSubscriptionDrawer } from '../../../utils/subscriptionDrawer';
import ServiceFeeIcon from '../ServiceFeeIcon';

import './style.scss';

const SelectButton = ({
    id,
    currentPrice,
    showServiceFeeIcon,
    onClick,
    openDrawerOnClick = false
}, { currencyConverter, general }) => {
    const formattedPrice = currencyConverter.convertWithFee(currentPrice);
    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;
    const btnType = openDrawerOnClick ? 'button' : 'submit';

    return (
        <>
            <div className="price-wrapper">
                <p className="tbody-5">{formattedPrice}</p>
                { showServiceFeeIcon && <ServiceFeeIcon packageId={id}/> }
            </div>
            <Button type={btnType} className="btn-select-package" color={btnColor} onClick={onClick}>
                <I18n k={'gig_page_perseus.packages_table.select'}/>
            </Button>
        </>
    );
};

SelectButton.propTypes = {
    currentPrice: number,
    showServiceFeeIcon: bool,
    openDrawerOnClick: bool
};

SelectButton.contextTypes = {
    currencyConverter: object,
    general: object
};

SelectButton.defaultProps = {
    onClick: () => true
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        currentPrice: packageData.currentPrice
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => {
        dispatch(selectPackage({ packageId: ownProps.id }));

        if (ownProps.openDrawerOnClick) {
            dispatch(setCheckoutDrawerOpen(true));
        }
    }
});

const SelectButtonConnect = connect(mapStateToProps, mapDispatchToProps)(SelectButton);

const SelectPackage = ({
    packageList,
    isRecurringGig = false,
    showServiceFeeIcon = false
}) => {
    const showTotalTitle = !isRecurringGig;
    const showSubscriptionDrawer = eligibleForSubscriptionDrawer();
    const openDrawerOnClick = isRecurringGig && showSubscriptionDrawer;

    return (
        <tr className="select-package">
            <th>
                {showTotalTitle && <I18n k={'gig_page_perseus.packages_table.total'}/>}
            </th>
            {packageList.map(({ id }) => (
                <td key={id}>
                    <SelectButtonConnect id={id}
                        showServiceFeeIcon={showServiceFeeIcon}
                        openDrawerOnClick={openDrawerOnClick}/>
                </td>
            ))}
        </tr>
    );
};

SelectPackage.propTypes = {
    packageList: array,
    isRecurringGig: bool,
    showServiceFeeIcon: bool
};

const mapSelectPackageStateToProps = ({ packages }) => {
    const { packageList } = packages;

    return {
        packageList,
        isRecurringGig: isRecurringGig(packages)
    };
};

export { SelectPackage, SelectButton };
export default connect(mapSelectPackageStateToProps)(SelectPackage);
